import client from 'apollo/client';

import type {
  CurrentUserLicenseStatusQuery,
  CurrentUserLicenseStatusQueryVariables
} from './CurrentUserLicenseStatus.queries.generated';
import {CurrentUserLicenseStatusDocument} from './CurrentUserLicenseStatus.queries.generated';
import {UserLicenseStatus} from 'gql/types';

export default async function getCurrentUserLicenseStatus() {
  try {
    const {data} = await client.query<
      CurrentUserLicenseStatusQuery,
      CurrentUserLicenseStatusQueryVariables
    >({
      query: CurrentUserLicenseStatusDocument,
      fetchPolicy: 'network-only'
    });
    return data?.currentUser?.licenseStatus ?? UserLicenseStatus.Guest;
  } catch (_e) {
    return UserLicenseStatus.Guest;
  }
}
